import {Injectable, Signal, inject, computed} from '@angular/core';

import {DimensionItem} from '@selpia/shared/models';

import {DimensionItemsStore} from '../state/dimension-items.store';
import {DimensionItemNode} from '../models';

@Injectable({
  providedIn: 'root',
})
export class DimensionItemsFacade {
  readonly #store: DimensionItemsStore = inject(DimensionItemsStore);

  readonly isLoading: Signal<boolean> = this.#store.loading;
  readonly items: Signal<Map<string, DimensionItem[]> | undefined> =
    this.#store.dimensionItems;

  readonly allItems = computed(() => {
    const items = this.items();
    if (!items) {
      return undefined;
    }
    return Array.from(items.values())
      .flat();
  });

  readonly itemsTrees: Signal<Map<string, DimensionItemNode> | undefined> = this.#store.dimensionItemsTrees;

  load() {
    this.#store.load();
  }
}
